import { useState } from "react";
import { clientCsvMapping, parseClientCsv, parseCsvRows, readClientCsv, type ClientColumn, type ClientImportRow } from "./client-csv";
import { track } from "./api";
const fields: Array<[ClientColumn, string]> = [["name","이름"],["phone","연락처"],["email","이메일"],["birthday","생일"],["privateNotes","메모"],["preferredStyle","선호 스타일"],["serviceFormula","시술식"]];
export function ClientCsvPicker({ onRows }: { onRows: (rows: ClientImportRow[]) => void }) {
  const [text, setText] = useState("");
  const [header, setHeader] = useState<string[]>([]);
  const [mapping, setMapping] = useState<Array<ClientColumn | "">>([]);
  const [message, setMessage] = useState("");
  const [encoding, setEncoding] = useState("");
  const preview = (value: string, columns: Array<ClientColumn | "">) => {
    try {
      const rows = parseClientCsv(value, columns);
      const valid = rows.filter(row => row.name.trim().length >= 2 && row.phone.replace(/\D/g, "").length >= 8);
      setMessage(`${rows.length}명 중 ${valid.length}명 옮길 수 있어요 · 연락처 빈 줄 ${rows.filter(row => !row.phone.trim()).length}개`);
      onRows(valid);
      track("switch_file_previewed", { rows: rows.length, mappedAuto: columns.join() === clientCsvMapping(parseCsvRows(value)[0] || []).join(), encoding });
    } catch (error) {
      onRows([]);
      setMessage(error instanceof Error && error.message === "csv_headers_required" ? "이름과 연락처가 어느 열인지 골라 주세요." : "한 번에 500명 이하의 CSV 파일인지 확인해 주세요.");
    }
  };
  return <div className="csv-picker">
    <label className="field"><span>쓰던 고객 장부 선택</span><input type="file" accept=".csv,.xlsx,.xls,text/csv" onChange={async event => {
      const file = event.target.files?.[0]; if (!file) return;
      try { const decoded = await readClientCsv(file); setEncoding(decoded.encoding); setText(decoded.text); const h = parseCsvRows(decoded.text)[0] || []; setHeader(h); const m = clientCsvMapping(h); setMapping(m); preview(decoded.text, m); }
      catch { setMessage("엑셀에서 '다른 이름으로 저장 → CSV'로 바꿔 올려 주세요."); onRows([]); }
    }} /></label>
    <p>파일은 이 브라우저에서만 읽어요. 장부 반영 버튼을 누르기 전에는 서버로 보내지 않아요.</p>
    {header.length > 0 && <details open={!mapping.includes("name") || !mapping.includes("phone")}><summary>열 짝짓기 · {encoding}</summary><div className="form-grid">{header.map((name, i) => <label className="field" key={`${i}-${name}`}><span>{name}</span><select value={mapping[i]} onChange={event => { const next = [...mapping]; next[i] = event.target.value as ClientColumn | ""; setMapping(next); preview(text, next); }}><option value="">옮기지 않기</option>{fields.map(([key,label]) => <option key={key} value={key}>{label}</option>)}</select></label>)}</div></details>}
    {message && <p role="status">{message}</p>}
  </div>;
}
